<template>
  <div class="search-input-container mobile-only">
    <div>
      <div class="search-input">
        <div class="search-icon">
          <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0V0z"/>
            <path d="M15.5 14h-.79l-.28-.27c1.2-1.4 1.82-3.31 1.48-5.34-.47-2.78-2.79-5-5.59-5.34-4.23-.52-7.79 3.04-7.27 7.27.34 2.8 2.56 5.12 5.34 5.59 2.03.34 3.94-.28 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
            />
          </svg>
        </div>
        <input 
          type="text" 
          :placeholder="$data._placeholder" 
          v-model="$data._searchText"
          v-on:click="showSearch"
          ref="input"
        />
      </div>
      <div class="button-container">
        <div class="button" v-on:click="showSearchButton">สร้างลิงก์</div>
      </div>
    </div>
    <div class="search-mobile" ref="searchMobile">
      <div class="header">
        <div class="back-icon" v-on:click="hideSearch">
          <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24"
          >
            <path opacity=".87" fill="none" d="M0 0h24v24H0V0z"/>
            <path d="M16.62 2.99c-.49-.49-1.28-.49-1.77 0L6.54 11.3c-.39.39-.39 1.02 0 1.41l8.31 8.31c.49.49 1.28.49 1.77 0s.49-1.28 0-1.77L9.38 12l7.25-7.25c.48-.48.48-1.28-.01-1.76z" />
          </svg>
        </div>
        <div class="text" v-on:click="hideSearch">กลับไปหน้าแรก</div>
      </div>
      <div class="input-container">
        <div class="search-icon">
          <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0V0z"/>
            <path d="M15.5 14h-.79l-.28-.27c1.2-1.4 1.82-3.31 1.48-5.34-.47-2.78-2.79-5-5.59-5.34-4.23-.52-7.79 3.04-7.27 7.27.34 2.8 2.56 5.12 5.34 5.59 2.03.34 3.94-.28 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
          </svg>
        </div>
        <input 
          type="text" 
          :placeholder="$data._placeholder" 
          v-model="$data._searchText"
          v-on:keyup.enter="search"
          v-on:keyup="search"
          v-on:click="search"
          ref="mobileInput"
        />
        <div class="delete-icon" v-on:click="clearText">ลบ</div>
      </div>
      <template v-if="$data._showGenerateLink">
        <generate-link :data="$data._linkData" />
      </template>
      <div v-else class="search-result">
        <template v-if="isEmptyString($data._searchText)">
          <div v-if="Object.keys($data._results).length === 0" class="loading">Loading ...</div>
          <no-result v-else-if="$data._results.datas && $data._results.datas.length < 1" />
          <template v-else-if="$data._results.datas && $data._results.datas.length > 0">
            <result-list
              :data="$data._results.datas"
              :showMoreResults="$data._showMoreResults"
              v-on:onResultClicked="showResult"
              v-on:onNextPage="nextPage"
              ref="searchContent"
            />
            <div class="footer">
              ไม่เจอร้านของคุณ? <br />
              <a 
                href="https://www.wongnai.com/delivery/business/signup?utm_source=lineman-sellers" 
                target="_blank" 
                rel="noopener noreferrer"
                class="green"
                v-on:onClick="trackAnalytics('link', 'registerRestaurant', 'searchResult-bottom')"
              >คลิกที่นี่</a> เพื่อลงทะเบียนร้านใหม่
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import ResultList from '@/components/result-list';
  import NoResult from '@/components/no-result';
  import GenerateLink from '@/components/generate-link';

  export default {
    components: {
      'result-list': ResultList,
      'no-result': NoResult,
      'generate-link': GenerateLink
    },
    props: {
      results: [Object],
      searchText: [String],
      placeholder: [String],
      showGenerateLink: [Boolean],
      linkData: [Object],
      showMoreResults: [Boolean],
    },
    data: () => ({
      _results: {},
      _searchText: '',
      _placeholder: '',
      _showGenerateLink: false,
      _linkData: {},
      _showMoreResults: false,
    }),
    watch: {
      results: function(results) {
        this.$data._results = results;
      },
      searchText: function(searchText) {
        this.$data._searchText = searchText
      },
      placeholder: function(placeholder) {
        this.$data._placeholder = placeholder;
      },
      showGenerateLink: function(showGenerateLink) {
        this.$data._showGenerateLink = showGenerateLink;
      },
      linkData: function(linkData) {
        this.$data._linkData = linkData;
      },
      showMoreResults: function(showMoreResults) {
        this.$data._showMoreResults = showMoreResults;
      }
    },
    methods: {
      trackAnalytics: function(category, action, label) {
        window.gtag('event', action, {
          event_category: category,
          event_label: label
        });
      },
      isEmptyString: function(str) {
        return str.replace(/\s/g, '');
      },
      hideSearch: function() {
        this.hide();
        this.$data._showGenerateLink = false;
        this.$data._searchText = '';
        this.$data._results = {};
      },
      show: function() {
        this.$refs.searchMobile.setAttribute('active', '');
      },
      hide: function() {
        this.$refs.searchMobile.removeAttribute('active');
        document.body.removeAttribute('search-active');
      },
      focusInput: function() {
        this.$refs.mobileInput.focus();
      },
      showSearch: function() {
        this.$emit('showSearch');
      },
      showSearchButton: function() {
        window.gtag('event', 'createLink', {
          event_category: 'button',
          event_label: 'searchBox'
        });
        if (!this.$data._searchText.replace(/\s/g, '')) {
          this.$emit('onError');
        }
        else {
          this.showSearch();
        }
      },
      search: function() {
        this.$data._showGenerateLink = false;
        const searchText = this.$data._searchText;
        this.$emit('onSearch', searchText);
      },
      showResult: function(index) {
        this.$data._showGenerateLink = true;
        this.$emit('showResult', index);
      },
      clearText: function() {
        this.$data._showGenerateLink = false;
        this.$data._searchText = '';
        this.$data._results = {};
      },
      nextPage: function() {
        this.$emit('onNextPage');
      },
    },
    mounted: function() {
      this.$data._results = this.results;
      this.$data._searchText = this.searchText;
      this.$data._placeholder = this.placeholder;
      this.$data._showGenerateLink = this.showGenerateLink;
      this.$data._linkData = this.linkData;
      this.$data._showMoreResults = this.showMoreResults;
    },
  }
</script>

<style lang="scss" scoped src="@/styles/input.scss"></style>
<style lang="scss" scoped>
  .search-input-container {
    width: 100%;
    padding: 0 24px;

    .button-container {
      .button {
        margin: 12px auto;
        width: auto;
      }
    }
  }

  .search-input {
    margin: 16px 0;
    width: 100%;
    max-width: 720px;
    height: 65px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    z-index: 2;
    background-color: #fff;
    border-radius: 5px;

    .search-icon {
      z-index: 1;
    }

    svg {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 20px;
      margin: auto;
      width: 32px;
      height: 32px;
      fill: #000;
    }
  }

  .search-result {
    position: absolute;
    background: #fff;
    width: 100%;
    max-height: 0;
    min-height: 85px;
    top: 0;
    box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.15);
    left: 0;
    border-radius: 5px;
    transition: 350ms max-height ease;
    padding-top: 85px;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    
    &[active] {
      height: auto;
      max-height: 75vh;
    }
    .footer {
      border-top: 1px solid rgba(0, 0, 0, 0.2);
      font-weight: 700;
      padding: 14px 0;
      margin: 0 24px;
      height: auto;
      display: block;
      color: #666;  
    }
  }

  .search-mobile {
    pointer-events: none;
    display: flex;
    flex-direction: column;
    position: fixed;
    background: #fff;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 4;
    padding: 16px 0 4px 0;
    opacity: 0;
    transform: translateY(80%);
    transition: 300ms transform ease, 250ms opacity ease;
    
    &[active] {
      opacity: 1;
      transform: translateY(0);
    }

    .header {
      padding: 8px 16px 20px 16px;
      display: flex;
      align-items: center;

      .back-icon {
        cursor: pointer;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        margin-right: 8px;

        &:hover {
          background: #f0f0f0;
        }
      
        svg {
          height: 20px;
          width: 20px;
        }
      }

      .text {
        cursor: pointer;
        font-size: 18px;
        font-weight: 700;
      }
    }

    .input-container {
      position: relative;
      padding: 0 16px;

      input {
        height: 60px;
        padding-right: 48px;
      }

      .search-icon svg {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 32px;
        margin: auto;
        width: 24px;
        height: 24px;
        fill: #000;
      }

      .delete-icon {
        height: 48px;
        width: 48px;
        border-radius: 50%;
        cursor: pointer;
        position: absolute;
        right: 18px;
        top: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 16px;
        color: #666666;

        &:hover {
          background: #f0f0f0;
        }
      }
    }
  }

  .loading {
    text-align: center;
    padding: 24px;
  }

  @media screen and (max-width: 720px) {
    .search-banner {
      .search {
        padding: 16px;
        .title {
          font-size: 32px;
          line-height: 42px;
        }
        .search-input {
          height: 65px;
          margin: 8px 0;
          background-color: #fff;
          border-radius: 5px;
          box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.15);

          .search-result {
            display: none;
          }
          .search-icon svg {
            width: 24px;
            height: 24px;
          }
        }
      }
      img {
        width: 100%;
      }
    }

    .search-result {
      padding-top: 0;
      height: 100%;
      min-height: auto;
      position: initial;
      max-height: initial;
      box-shadow: none;
    }

    .search-mobile[active] {
      opacity: 1;
      transform: translateY(0);
      pointer-events: visible;
    }
  }
</style>